import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputRootFn = /* @__PURE__ */ createRecipe('input-root', {
  "direction": "column"
}, [])

const inputRootVariantMap = {
  "direction": [
    "row",
    "column"
  ]
}

const inputRootVariantKeys = Object.keys(inputRootVariantMap)

export const inputRoot = /* @__PURE__ */ Object.assign(memo(inputRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputRoot',
  __getCompoundVariantCss__: inputRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputRootVariantKeys,
  variantMap: inputRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputRootVariantKeys)
  },
  getVariantProps: inputRootFn.getVariantProps,
})